export default __webpack_public_path__ + "static/media/TokiRGB.0e9b15cf.png";